import * as React from "react"
import { cn } from "../lib/utils"
import { Label } from "./Label"

interface FieldProps {
  label?: React.ReactNode
  htmlFor?: string
  required?: boolean
  /** Validation error message. */
  error?: string
  /** Helper text shown below the control when there is no error. */
  hint?: string
  className?: string
  children: React.ReactNode
}

/** Standard form field: label + control + helper/error. */
export function Field({
  label,
  htmlFor,
  required,
  error,
  hint,
  className,
  children,
}: FieldProps) {
  return (
    <div className={cn("space-y-1.5", className)}>
      {label && (
        <Label htmlFor={htmlFor} required={required}>
          {label}
        </Label>
      )}
      {children}
      {error ? (
        <p className="text-xs font-medium text-destructive">{error}</p>
      ) : hint ? (
        <p className="text-xs text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  )
}

/** Visual grouping with a heading inside a form. */
export function FormSection({
  title,
  description,
  children,
  className,
}: {
  title: string
  description?: string
  children: React.ReactNode
  className?: string
}) {
  return (
    <section className={cn("space-y-5", className)}>
      <div>
        <h3 className="text-foreground font-display text-card-title">{title}</h3>
        {description && (
          <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {children}
    </section>
  )
}
